import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Image from './Image'
import uuid from 'react-uuid'
//Redux
import { setImages } from '../../../redux'
import { useSelector, useDispatch } from 'react-redux'

function ImageManager(props) {
  const { imageRefresh, saveRefresh, pageNumber, imageUrl, type, isSignature, handleRecords } = props

  const [imageArray, setImageArray] = useState([])
  const dispatch = useDispatch()
  const page = useSelector((state) => state.document.page)

  useEffect(() => {
    if (imageRefresh && imageRefresh !== 0) addImage()
  }, [imageRefresh])

  useEffect(() => {
    if (saveRefresh && saveRefresh !== 0) saveImages()
  }, [saveRefresh])

  const addImage = () => {
    setImageArray([
      ...imageArray,
      {
        id: uuid(),
        pageNumber: pageNumber,
        type: type,
        isSignature: isSignature,
        imgUrl: imageUrl,
        imgLeft: page.offsetLeft + 50,
        imgTop: page.offsetTop + 50,
        imgHeight: 100,
        imgWidth: 100,
        angle: 0,
        offsetLeft: page.offsetLeft,
        offsetTop: page.offsetTop,
        multiplier: page.originalPageHeight / page.pageHeight,
        pageHeight: page.pageHeight,
        pageWidth: page.pageWidth,
      },
    ])
    handleRecords(pageNumber, isSignature ? 'signature' : 'image', 'increment')
  }

  const saveImages = () => {
    dispatch(setImages(imageArray))
  }

  const deleteImage = (id) => {
    setImageArray(imageArray.filter((img) => img.id !== id))
    handleRecords(pageNumber, isSignature ? 'signature' : 'image', 'decrement')
  }

  const updateImage = (state) => {
    setImageArray(imageArray.map((img) => (img.id === state.id ? { ...img, ...state } : img)))
  }

  return (
    <div>
      {imageArray.map((image) => {
        return <Image key={image.id} updateImage={updateImage} deleteImage={deleteImage} image={image} />
      })}
    </div>
  )
}

ImageManager.propTypes = {
  imageRefresh: PropTypes.number.isRequired,
  saveRefresh: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  type: PropTypes.string,
  isSignature: PropTypes.bool.isRequired,
  handleRecords: PropTypes.func.isRequired,
}

export default ImageManager
